document.addEventListener("DOMContentLoaded", function () {
    console.log("section-article-share.js loaded")

    const $articleShare = $("section.article-share")
    const $articleShareTextWrapper = $articleShare.find(".wrapper>div:first-child")
    const $shareIcons = $articleShare.find(".share-icons")

    const $emailButton = $shareIcons.find(".share-icon[data-type='email']")
    const $instagramButton = $shareIcons.find(".share-icon[data-type='instagram']")
    const $facebookButton = $shareIcons.find(".share-icon[data-type='facebook']")

    $emailButton.on("click", function () {
        const url = window.location.href
        const title = document.title
        const body = `Check out this article: ${title} at ${url}`
        window.location.href = `mailto:?subject=${title}&body=${body}`
    })

    $articleShareTextWrapper.on("click", function () {
        shareUsingNavigatorAPI()
    })

    $instagramButton.on("click", function () {
        shareUsingNavigatorAPI()
    })

    $facebookButton.on("click", function () {
        const url = window.location.href
        window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${url}`,
            "_blank"
        )
    })

    function shareUsingNavigatorAPI() {
        if (navigator.share) {
            navigator.share({
                title: document.title,
                text: document.title,
                url: window.location.href,
            })
        }
    }
})
